<div class="main">
    <div class="section">
        <div class="header">
            <div class="label">
                Epods Preview
            </div>
            <div class="close">
                <button mat-icon-button class="close-button" [mat-dialog-close]="true">
                    <mat-icon class="close-icon">close</mat-icon>
                </button>
            </div>
        </div>
        <div class="body">
            <div class="left">
                <div class="imagePreviewSection">
                    <img *ngIf="isImage" [src]="previewImage" alt="No Epod found" />
                    <app-pdf-viewer *ngIf="isPdf" [src]="previewPdf" [full]="false" style="width: 98%;
    height: 100%;overflow-y: auto;overflow-x: hidden;"></app-pdf-viewer>
                     <div class="buttons">
                        <div class="downloadEpod">
                            <div>
                                <span *ngIf="previewPdf && !isImage">
                                    {{'EPODPREVIEW.downloadEpod' | translate}}
                                    <a  [href]="previewPdf" download>
                                         <img src="assets/download_icon.svg"   style="color: #dfe3eb;    width: 24px;">
                                    </a>
                                </span>
                                <span *ngIf="previewImage && isImage">
                                    {{'EPODPREVIEW.downloadEpod' | translate}}
                                    <a  [href]="previewImage" download>
                                         <img src="assets/download_icon.svg"   style="color: #dfe3eb;    width: 24px;">
                                    </a>
                                </span>
                                 
                            </div>
                        </div>
                        <div class="zoomEpod">
                            <div>
                                {{'EPODPREVIEW.zoomEpod' | translate}}
                            </div>
                            
                                <img src="assets/preview_icon.svg" (click)="openImagePopup()" class="downloadIcon" style="color: #dfe3eb; padding-top: 2px;">
                            
                        </div>
                        <div class="deleteEpod" *ngIf="showCloseButton">
                            <div>
                                {{'EPODPREVIEW.deleteheading' | translate}}
                            </div>
                            <div>
                                <mat-icon  class="close-icon" (click)="deleteEpod()">close</mat-icon>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="epodsSection">
                    <div *ngFor="let image of imageList" class="epod">
                        <img *ngIf="image.split('.')[image.split('.').length - 1] != 'pdf'" [src]="image" alt="Image"
                            (click)="showPreview(image)" />
                        <mat-icon *ngIf="image.split('.')[image.split('.').length - 1] == 'pdf'" class="close-icon"
                            (click)="showPreview(image)">picture_as_pdf</mat-icon>
                    </div>
                </div>
                <div class="approvalScreen" *ngIf="isRejecting">
                    <div class="epblock">
                        <div class="epheader">
                            {{'SHIPMENTDETAILS.rejection_reason' | translate}}
                        </div>
                        <div class="epsection">
                            <div class="epreasonBox">
                                <textarea rows="7" [placeholder]=" 'SHIPMENTDETAILS.reason' | translate "
                                    autofocus="false" [(ngModel)]="reject_reason"> </textarea>
                            </div>
                            <div class="epbuttons">
                                <div class="newButton" style="background-color: #0e1013;" (click)="closeReasonBox();">
                                    <div class="label">
                                        {{'EXTEND_ASSIGNMENT.cancel' | translate}}
                                    </div>
                                </div>
                                <div class="newButton" (click)="submitReason();">
                                    <div class="label">
                                        {{'EXTEND_ASSIGNMENT.submit' | translate}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="right">
                <div class="topRight">
                    <div class="input do_number_select">
                        <mat-form-field appearance="outline" style="outline: none;width: 100%;">
                            <mat-label
                                    style="font-size: 12px !important;font-weight: bold;">DO Number(s)</mat-label>
                        <mat-select class="inputSelect"panelClass="do_number_options" style="color: #fff;" [(value)]="selectedInvoice.commercial_invoices[0].others.do_number">
                            <input matInput  (keyup)="applyFilter($event.target.value)" placeholder="Search DO Numbers" style="outline: none;
                            height: 24px;
                            border: solid 1px #e3e3e3;
                            width: 93%;
                            margin: 2%;
                            border-radius: 4px;
                            padding-left: 6px;
                            font-size: 14px;
                            color: #42454E;">
                            <mat-option *ngFor="let inv of filteredInvoiceList" [value]="inv.commercial_invoices[0].others.do_number"
                                (onSelectionChange)="selectInvoice($event, inv)">
                                {{inv.commercial_invoices[0].others.do_number}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    </div>
                    <div class="category">
                        <div class="rowDetails">
                            <div class="label">
                                Customer Name:
                            </div>
                            <div class="value" [title]="customerName">
                                {{customerName}}
                            </div>
                        </div>
                        <div class="rowDetails">
                            <div class="label">
                                Epod Upload Date:
                            </div>
                            <div class="value">
                                {{epodUploadDate}}
                            </div>
                        </div>
                        <div class="rowDetails">
                            <div class="label">
                                Received Quantity by Customer:
                            </div>
                            <div class="value">
                                {{receivedQty}}
                            </div>
                        </div>
                    </div>
                    <div class="category">
                        <div class="rowDetails">
                            <div class="label">
                                No of Pieces:
                            </div>
                            <div class="value">
                                {{noOfPieces}}
                            </div>
                        </div>
                        <div class="rowDetails">
                            <div class="label">
                                Shipped Quantity:
                            </div>
                            <div class="value">
                                {{totalWeight}} MT
                            </div>
                        </div>
                        <div class="rowDetails">
                            <div class="label">
                                Plant Code:
                            </div>
                            <div class="value">
                                {{plantCode}}
                            </div>
                        </div>
                        <div class="rowDetails">
                            <div class="label">
                                DO Numbers:
                            </div>
                            <div class="value" [title]="doNumbers">
                                {{doNumbers}}
                            </div>
                        </div>
                    </div>
                    <div class="category">
                        <div class="rowDetails">
                            <div class="label">
                                Invoice Number:
                            </div>
                            <div class="value" [title]="invoiceNumber">
                                {{invoiceNumber}}
                            </div>
                        </div>
                        <div class="rowDetails">
                            <div class="label">
                                LR Number:
                            </div>
                            <div class="value" [title]="lrNumber">
                                {{lrNumber}}
                            </div>
                        </div>
                        <div class="rowDetails">
                            <div class="label">
                                Delivery Completion Date:
                            </div>
                            <div class="value">
                                {{deliveryCompletionDate}}
                            </div>
                        </div>
                    </div>



                </div>

            </div>
        </div>
    </div>
</div>
<div id="myPopup">
    <div class="close_btn">
        <i class="material-icons close_icon" (click)="closePopup()">
            clear
        </i>
    </div>
    <div class="body">
        <img *ngIf="isImage" [src]="previewImage" alt="No Epod found" />
        <app-pdf-viewer *ngIf="isPdf" [src]="previewPdf" [full]="true" style="width: 98%;overflow:auto;
            height: 100%;"></app-pdf-viewer>
    </div>
</div>